import {useEffect, useState} from 'react'
import { useStore } from '../../../../context/Store';
import Card from '../component/Card.component'
import LocationOnIcon from '@material-ui/icons/LocationOn';
import StoreIcon from '@material-ui/icons/Store';
import QueryBuilderIcon from '@material-ui/icons/QueryBuilder';
import GridComponentComponent from '../../../../component/grid/GridComponent.component';
import Grid from '@material-ui/core/Grid';
import {formatDistance, format} from 'date-fns';
import { http } from '../../../../services/apiSecurity/Http.interceptor';
import { getUserById } from '../User.service';
import { formatTelephone } from '../../../../utils/format/FormatTelefone';
import { useParams } from 'react-router-dom';
import { Store } from '../../interfaces/Store';


 interface StoreData {
  id: string;
  semanaInicio: string;
  semanaFim: string;
  sabadoInicio: string;
  sabadoFim: string;
  domingoInicio: string;
  domingoFim: string;
}

interface StoreDataException {
  dtInicio: string;
  dtFim: string;
  hrInicio: string;
  hrFim: string;
  Observacao: string;
  tipoDeHorario: string;
}


export default function Information() {
  const INITIAL_COMP_DATA = {
    formatDescription: '',
    regionDescription: '',
    regionManagerName: '',
    regionManagerPhone: '',
  }

  const params: {id?: string} = useParams();

  const [semana, setSemana] = useState('');
  const [sabado, setSabado] = useState('');
  const [domingo, setDomingo] = useState('');
  const [excecao, setExcecao] = useState<string[]>([]);
  const [feriado, setFeriado] = useState<string[]>([]);
  const [dadosComp, setDadosComp] = useState({...INITIAL_COMP_DATA})
  const [selectedStore, setSelectedStore] = useState<Store | null>();

  useEffect(() => {
    if(params.id){
      http.get(`/stores/${params.id}`).then(r => {
        setSelectedStore(r.data)
      }).catch(() => {
        setSelectedStore(null)
      })
    }
  },[])

  

  const formatHours = (data:Store, dataException:StoreDataException[]) => {
    var semana = '';
    var sabado = '';
    var domingo = '';
    var exception = '';

    if(Object.getOwnPropertyNames(data).length > 0 ) {
      if((data.semanaInicio && data.semanaFim) && data.semanaInicio === data.sabadoInicio && data.semanaInicio === data.domingoInicio
        && data.semanaFim === data.sabadoFim && data.semanaFim === data.domingoFim) {
          if(data.semanaInicio === "00:00:00" && data.semanaFim === "00:00:00"){
            semana = `Segunda a Domingo: FECHADA`
          } else {
            semana = `Segunda a Domingo: ${data.semanaInicio.replace(/(:\d{2}| [AP]M)$/, "")} às ${data.semanaFim.replace(/(:\d{2}| [AP]M)$/, "")}`
          }
      } else if((data.semanaInicio && data.semanaFim) && data.semanaInicio === data.sabadoInicio && data.semanaFim !== data.domingoFim
        && data.semanaFim === data.sabadoFim) {
          semana = `Segunda a Sábado: ${data.semanaInicio.replace(/(:\d{2}| [AP]M)$/, "")} às ${data.semanaFim.replace(/(:\d{2}| [AP]M)$/, "")}`
          domingo = (data.domingoInicio && data.domingoInicio !== '00:00:00') && (data.domingoFim && data.domingoFim !== '00:00:00') ? `Domingo: ${data.domingoInicio.replace(/(:\d{2}| [AP]M)$/, "")} às ${data.domingoFim.replace(/(:\d{2}| [AP]M)$/, "")}` : ''
      } else {
        if(data.semanaInicio && data.semanaFim){
          semana = `Segunda a Sexta: ${data.semanaInicio.replace(/(:\d{2}| [AP]M)$/, "")} às ${data.semanaFim.replace(/(:\d{2}| [AP]M)$/, "")}`
        }

        if((data.sabadoInicio && data.sabadoFim) && data.sabadoInicio === data.domingoInicio && data.sabadoFim === data.domingoFim && data.sabadoInicio !== '00:00:00') {
          sabado = `Sábado e Domingo: ${data.sabadoInicio.replace(/(:\d{2}| [AP]M)$/, "")} às ${data.sabadoFim.replace(/(:\d{2}| [AP]M)$/, "")}`
        } else if (data.sabadoInicio && data.sabadoFim && data.domingoInicio && data.domingoFim) {
          sabado = data.sabadoInicio !== '00:00:00' && data.sabadoFim !== '00:00:00' ?`Sábado: ${data.sabadoInicio.replace(/(:\d{2}| [AP]M)$/, "")} às ${data.sabadoFim.replace(/(:\d{2}| [AP]M)$/, "")}`: ''
          domingo = data.domingoInicio !== '00:00:00' && data.domingoFim !== '00:00:00' ? `Domingo: ${data.domingoInicio.replace(/(:\d{2}| [AP]M)$/, "")} às ${data.domingoFim.replace(/(:\d{2}| [AP]M)$/, "")}` : ''
        }
      }
    }


    const sortDataException = dataException.sort(function(a:StoreDataException,b:StoreDataException){
      return +new Date(a.dtInicio) - +new Date(b.dtInicio);
    });


   const exceptionArray = sortDataException.filter((ex) => ex.tipoDeHorario === 'E').map((data) => {
      if(compareDate(data.dtInicio) || expiredDate(data.dtFim)) {
          const dataInicio = format(new Date(data.dtInicio), 'dd/MM/yyyy');

          if(data.dtFim !== '0000-00-00' && data.dtInicio !== data.dtFim) {
            const dataFim = format(new Date(data.dtFim), 'dd/MM/yyyy');
            exception = `${data.Observacao}: ${dataInicio} a ${dataFim}`

            if(data.hrInicio === '00:00:00' && data.hrFim === '23:59:59') {
              exception = `${exception} - FECHADA`
            } else {
             exception = `${exception} - ${data.hrInicio.replace(/(:\d{2}| [AP]M)$/, "")} às ${data.hrFim.replace(/(:\d{2}| [AP]M)$/, "")}`;
            }

            return exception;
          } else {
            exception = `${data.Observacao}: ${dataInicio}`

            if(data.hrInicio === '00:00:00' && data.hrFim === '23:59:59') {
              exception = `${exception} - FECHADA`
            } else {
              exception = `${exception} - ${data.hrInicio.replace(/(:\d{2}| [AP]M)$/, "")} às ${data.hrFim.replace(/(:\d{2}| [AP]M)$/, "")}`;
            }
            return exception;
          }
      }
      return '';
   })

   const holidayArray = sortDataException.filter((ex) => ex.tipoDeHorario === 'F').map((data) => {
    if(compareDate(data.dtInicio) || expiredDate(data.dtFim)) {
         const dataInicio = format(new Date(data.dtInicio), 'dd/MM/yyyy');
         if(data.hrInicio === '00:00:00' && data.hrFim === '23:59:59') {
          exception = `${data.Observacao}: ${dataInicio} - FECHADA`
         } else {
          exception = `${data.Observacao}: ${dataInicio} - ${data.hrInicio.replace(/(:\d{2}| [AP]M)$/, "")} às ${data.hrFim.replace(/(:\d{2}| [AP]M)$/, "")}`
         }

        return exception
    }
    return '';
 })

    setSemana(semana);
    setSabado(sabado);
    setDomingo(domingo);
    setExcecao(exceptionArray);
    setFeriado(holidayArray);
  }

  const compareDate = (date:string) => {
    const formatedDate = new Date(format(new Date(date), 'yyyy-MM-dd'))
    const dateNow = new Date(format(new Date(), 'yyyy-MM-dd'));

    const distance = formatDistance(formatedDate, dateNow, {addSuffix:true});
    const splitDistance = distance.split(" ");

    if(splitDistance.length === 3) {
      if(splitDistance[2] === 'ago') return false;
      if(Number(splitDistance[1]) > 15) return false;
      return true;
    } else {
      if(splitDistance[3] === 'ago') return false;
      return true;
    }

  }

  const expiredDate = (date:string|undefined) => {
    if(date === '' || date === undefined) return false;

    const formatedDate = new Date(format(new Date(date), 'yyyy-MM-dd'))
    const dateNow = new Date(format(new Date(), 'yyyy-MM-dd'));

    const distance = formatDistance(formatedDate, dateNow, {addSuffix:true});
    const splitDistance = distance.split(" ");


    if(splitDistance.length === 3) {
      if(splitDistance[2] === 'ago') return false;
      return true;
    } else {
      if(splitDistance[3] === 'ago') return false;
      return true;
    }

  }

  const getDadosComplementares = async() => {
    let payload = {...INITIAL_COMP_DATA}
    let responsePayload

    try {
      responsePayload = await (await http.get(`/exceptiondays?store=${selectedStore?.id}`)).data.data
    } catch {}
    
    if(selectedStore && responsePayload){
      formatHours(selectedStore, responsePayload)

      try {
        responsePayload = await (await http.get(`/formats/${selectedStore?.format_id}`)).data  
        payload.formatDescription = responsePayload.description
      } catch {}

      try {
        responsePayload = await (await http.get(`/regions/${selectedStore?.region_id}`)).data  
        payload.regionDescription = responsePayload.description
        payload.regionManagerPhone = formatTelephone(responsePayload.managerPhone) 

        if(responsePayload.managerAd){
          responsePayload = await getUserById(responsePayload.managerAd)
          payload.regionManagerName = responsePayload.data.user.cn  
        }
      } catch {}

     setDadosComp(payload)
    }
   
    
  }

  useEffect(() => {
    if(selectedStore){
      getDadosComplementares()
    }
  },[selectedStore])

  return (
    <GridComponentComponent spacing={2} alignItems='flex-start' justify='center' margin='20px 0px'>
      <Grid item xs={12} sm={12} md={6} >

        <Card icon={<StoreIcon color='primary' />} title='Loja' >
          <div>{selectedStore?.id}: {selectedStore?.Nome}</div>
          <div>Formato: {dadosComp.formatDescription}</div>
          <div>Gerente: {selectedStore?.managerName} - {formatTelephone(selectedStore?.managerPhone || '')}</div>
          <div>Regional: {dadosComp.regionDescription}</div>
          <div style={{marginBottom: '10px'}}>Ger. Regional: {dadosComp.regionManagerName} - {dadosComp.regionManagerPhone}</div>
        </Card>

        <Card icon={<LocationOnIcon color='primary' />} title='Endereço'>
          <div>{selectedStore?.Logradouro}, {selectedStore?.NumeroEstabelecimento}</div>
          <div>{selectedStore?.Bairro}</div>
          <div>{selectedStore?.Cidade} - {selectedStore?.UF}</div>
          <div>CEP: {selectedStore?.Cep}</div>
          <div style={{marginBottom: '10px'}}>Fone: {formatTelephone(selectedStore?.Telefone || '')}</div>
        </Card>

      </Grid>
      <Grid item xs={12} sm={12} md={6}>
        <Card icon={<QueryBuilderIcon color='primary' />} title='Horário de funcionamento'>
          {semana !== '' && semana }
          <br />
          {sabado !== '' && sabado }
          {sabado !== '' && <br /> }
          {domingo !== '' && domingo }
          {domingo !== '' && <br />}
          <br />

          {excecao.length > 0 &&
              <div style={{display:'flex', flexDirection:'column'}}>
                <span>Data de exceção:</span>
                <ul style={{marginTop: '4px'}}>
                  {excecao.map((ex, index) => {
                    return (
                      <li key={index}>{ex}</li>
                    )
                  })}
                </ul>
              </div>
           }
           {feriado.length > 0  &&
             <div style={{display:'flex', flexDirection:'column'}}>
              <span>Feriado:</span>
              <ul style={{marginTop: '4px'}}>
                {feriado.map((ex, index) => {
                  return (
                    <li key={index}>{ex}</li>
                  )
                })}
              </ul>
            </div>
           }
        </Card>

      </Grid>
    </GridComponentComponent>
  )
}
